import { HJson } from "@macashipo/mlib"

export const getObj = HJson.getObj
export const getString = HJson.getString
export const json2Obj = HJson.json2Obj
export const obj2Json = HJson.getString
